import { useEffect, useState } from "react";
import CarrierHeader from "../../components/CarrierHeader";
import api from "../../utils/axiosInstance";

const PaymentHistory = () => {
    const [payments, setPayments] = useState([]);
    const storedUser = JSON.parse(localStorage.getItem("carrierUser"));

    useEffect(() => {
        if (!storedUser?._id) return;

        const fetchPayments = async () => {
            try {
                const { data } = await api.get(
                    `/payment/history/${storedUser._id}`
                );
                if (data.success) {
                    setPayments(data.payments);
                }
            } catch (err) {
                console.error("Error fetching payment history:", err);
            }
        };

        fetchPayments();
    }, [storedUser]);

    return (
        <div className="bg-gray-100 text-dark min-h-screen lg:pl-64">
            {/* Header */}
            <CarrierHeader />

            {/* Card */}
            <div className="bg-gradient-to-br from-white to-gray-100 rounded-2xl p-6 shadow-xl hover:-translate-y-1 transition duration-300 mt-6 mx-4">
                <div className="flex items-center gap-4 mb-5 pb-4 border-b-2 border-[#3c9bf9]">
                    <h2 className="text-xl font-semibold text-gray-900">
                        Payment History
                    </h2>
                </div>

                {/* Table */}
                <div className="overflow-x-auto">
                    <table className="min-w-full border border-gray-200 rounded-lg shadow-md text-sm">
                        <thead className="bg-[#3c9bf9] text-white text-left">
                            <tr>
                                <th className="py-2 px-4">Package</th>
                                <th className="py-2 px-4">Amount</th>
                                <th className="py-2 px-4">Transaction ID</th>
                                <th className="py-2 px-4">Start Date</th>
                                <th className="py-2 px-4">End Date</th>
                                <th className="py-2 px-4">Created At</th>
                            </tr>
                        </thead>
                        <tbody>
                            {payments.length === 0 ? (
                                <tr>
                                    <td
                                        colSpan="6"
                                        className="text-center py-6 text-gray-500"
                                    >
                                        No payment records found.
                                    </td>
                                </tr>
                            ) : (
                                payments.map((payment) => (
                                    <tr
                                        key={payment._id}
                                        className="border-t hover:bg-[#3c9bf9]/5 transition duration-200"
                                    >
                                        <td className="py-2 px-4">{payment.packageName}</td>
                                        <td className="py-2 px-4">${payment.amount}</td>
                                        <td className="py-2 px-4">{payment.transactionId}</td>
                                        <td className="py-2 px-4">
                                            {new Date(payment.startDate).toLocaleDateString()}
                                        </td>
                                        <td className="py-2 px-4">
                                            {new Date(payment.endDate).toLocaleDateString()}
                                        </td>
                                        <td className="py-2 px-4">
                                            {new Date(payment.createdAt).toLocaleString()}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default PaymentHistory;
